import React, { ReactNode } from 'react'

import * as Styled from './Table.styled'

type Item = {
  id: string
  label: string
  description: string | ReactNode
}

type Props = {
  data: Item[]
}

const Table = ({ data }: Props) => {
  return (
    <Styled.Table>
      {data.map(item => (
        <Styled.Item key={item.id}>
          <Styled.Label>{item.label}</Styled.Label>
          <Styled.Text>{item.description}</Styled.Text>
        </Styled.Item>
      ))}
    </Styled.Table>
  )
}

export default Table
